<script>
    import {Input} from '../components/ui';

    export let model;
</script>

<div>
    <Input bind:model={model.text}/>
</div>